import axios from 'axios';
import {BASE_URL} from '../utils/constants';

let cached = null;
const TTL = 30000;
export const invalidateFilterData = () => { cached = null; };
export const fetchFilterData = (auth, params) => {
  const key = JSON.stringify([
    auth.sessionId, auth.token, auth.user?._id, auth.user?.access, auth.user?.subAccount,
    params.publisherView, params.partition
  ]);
  if (cached?.key === key && (cached.pending || cached.expires > Date.now())) return cached.promise;
  const entry = {key, pending: true, expires: 0};
  entry.promise = axios.get(`${BASE_URL}/api/reports/filter-data`, {params})
    .then(({data}) => {
      if (!data?.success) throw new Error('Could not load filter values');
      entry.pending = false;
      entry.expires = Date.now() + TTL;
      return data;
    })
    .catch(error => {
      if (cached === entry) cached = null;
      throw error;
    });
  cached = entry;
  return entry.promise;
};
